// src/documents/_shared.js
// symbols.js ve views.js arasında paylaşılan DXF entity rotation + ID helper'ları.
// Önceden her iki dosyada birebir aynı kod ile kopyalanmıştı (#8).

export function dondur(objects, aci, centerX, centerY) {
  // Dereceyi radyana çevir
  const angleRad = (Math.PI / 180) * aci;

  return objects.map((nesne) => {
    switch (nesne.type) {
      case 'LINE': {
        // LINE nesnesinin 2 noktalı (veya birden fazla noktalı) 'vertices' array'ini döndürüyoruz
        const newVertices = nesne.vertices.map((v) =>
          rotatePoint(centerX, centerY, v.x, v.y, angleRad)
        );
        return { ...nesne, vertices: newVertices };
      }

      case 'LWPOLYLINE': {
        // LWPOLYLINE de benzer şekilde çoklu vertices içerir
        const newVertices = nesne.vertices.map((v) =>
          rotatePoint(centerX, centerY, v.x, v.y, angleRad)
        );
        return { ...nesne, vertices: newVertices };
      }

      case 'CIRCLE': {
        // CIRCLE sadece center etrafında döner
        const newCenter = rotatePoint(centerX, centerY, nesne.center.x, nesne.center.y, angleRad);
        return {
          ...nesne,
          center: { ...nesne.center, x: newCenter.x, y: newCenter.y }
        };
      }

      case 'ARC': {
        // ARC için hem center döndürülür hem de açıları güncelleriz (startAngle ve endAngle)
        const newCenter = rotatePoint(centerX, centerY, nesne.center.x, nesne.center.y, angleRad);
        const newStartAngle = (nesne.startAngle + angleRad) % 360;
        const newEndAngle = (nesne.endAngle + angleRad) % 360;
        return {
          ...nesne,
          center: { ...nesne.center, x: newCenter.x, y: newCenter.y },
          startAngle: newStartAngle,
          endAngle: newEndAngle
        };
      }

      case 'TEXT': {
        const textX = nesne.startPoint?.x ?? nesne.x;
        const textY = nesne.startPoint?.y ?? nesne.y;
        const newTextXY = rotatePoint(centerX, centerY, textX, textY, angleRad);
        const newRotation = (nesne.rotation || 0) + (aci || 0);
        const result = { ...nesne, x: newTextXY.x, y: newTextXY.y, rotation: newRotation };
        if (nesne.startPoint) {
          result.startPoint = { ...nesne.startPoint, x: newTextXY.x, y: newTextXY.y };
        }
        return result;
      }

      default:
        // Tanımlı olmayan type'larda dönüşüm yapılmaz, aynen döndür.
        return nesne;
    }
  });
}

export function rotatePoint(cx, cy, px, py, angleRad) {
  // Merkezden noktaya göre vektör
  const dx = px - cx;
  const dy = py - cy;
  // Döndürme matrisi uygulama
  const rotatedX = dx * Math.cos(angleRad) - dy * Math.sin(angleRad);
  const rotatedY = dx * Math.sin(angleRad) + dy * Math.cos(angleRad);
  // Tekrar merkez koordinatlarına ekle
  return { x: cx + rotatedX, y: cy + rotatedY };
}

let counter = 0;
export function generateTimestampedId() {
  counter++;
  const timestamp = Date.now(); // Milisaniye cinsinden zaman
  return `id-${timestamp}-${counter}`;
}
